import React from "react";
import { convertStraight, convertThenFormat } from "../../common-data/Converts";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const DetailListings = ({ row, isOnlyInfo }) => {
  return (
    <>
      <div className="user-profile-container staff-onboarding-detail-modal">
        {isOnlyInfo ? (
          <div className="user-profile-details">
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Approval Status</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {row?.approval_status === "approved" ? (
                    <CheckCircleIcon />
                  ) : row?.approval_status === "rejected" ? (
                    <CrossCircleIcon />
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-hourglass-split"
                      viewBox="0 0 16 16"
                      style={{ color: "#d9610b" }}
                    >
                      <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                    </svg>
                  )}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">
                  {row?.approval_status?.replace(/_/g, " ")} By
                </p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {/* {row?.approved_by || "NA"} */}
                  {row?.approved_by_name || "NA"} /
                  {row?.approved_by_mobile || ""}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">remark</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">{row?.remark || "NA"}</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="user-profile-details">
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Plan Name</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">{row?.plan_name || "NA"}</p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">plan duration</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {row?.start_date ? convertStraight(row.start_date) : "-"}{" "}
                  <b>TO</b>{" "}
                  {row?.expire_date ? convertStraight(row.expire_date) : "-"} (
                  {row?.plan_duration || 0} Days)
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">extend days</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">{row?.extend_days || 0} Days</p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">Plan Price</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  ₹{convertThenFormat(row?.plan_price || 0)}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DetailListings;
